import React from "react";
import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';

// third-party
import {SnackbarProvider } from 'notistack';

// project import
import { useSelector } from 'react-redux';

// assets
import { IconCircleCheck, IconSquareRoundedX, IconInfoCircle, IconAlertCircle } from '@tabler/icons-react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
// import { closeSnackbar } from "../../../../store/slices/snackbarSlice";
// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
    '&.notistack-MuiContent-default': {
        backgroundColor: theme.palette.primary.main
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: theme.palette.error.main
    },
    '&.notistack-MuiContent-success': {
        backgroundColor: theme.palette.success.main
    },
    '&.notistack-MuiContent-info': {
        backgroundColor: theme.palette.info.main
    },
    '&.notistack-MuiContent-warning': {
        backgroundColor: theme.palette.warning.main
    }
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

const Notistack = ({ children }) => {
    const snackbar = useSelector((state) => state.snackbar);
    const iconSX = { marginRight: 8, fontSize: '1.15rem' };
    const myRef = React.useRef(null)
    const handleClose = (event, key) => {
        myRef.current.handleCloseSnack(event, false, key)
    };
    return (
        <StyledSnackbarProvider
            ref={myRef}
            sx={{
                zIndex: 3000, // Higher than your footer's z-index
            }}
            autoHideDuration={2000}
            maxSnack={snackbar.maxStack}
            dense={snackbar.dense}
            iconVariant={
                snackbar.iconVariant === 'useemojis'
                    ? {
                          success: <IconCircleCheck style={iconSX} />,
                          error: <IconSquareRoundedX style={iconSX} />,
                          warning: <IconInfoCircle style={iconSX} />,
                          info: <IconAlertCircle style={iconSX} />
                      }
                    : undefined
            }
            // eslint-disable-next-line
            hideIconVariant={snackbar.iconVariant === 'hide'}
            anchorOrigin={{
                vertical: "bottom", // top or bottom
                horizontal: "right", // left, center, or right
            }}
            action={(key) => (
                <IconButton
                    onClick={(event) => handleClose(event, key)} // Close snackbar on click
                    color="inherit"
                >
                      <CloseIcon />
                  </IconButton>
             )}
        >
            {children}
        </StyledSnackbarProvider>
    );
};

Notistack.propTypes = {
    children: PropTypes.node
};

export default Notistack;
